import { action, computed, makeObservable, observable } from "mobx"

import { DepositPayment } from "@src/pages/transactionsDeposits/classes/TransactionsDepositsCollection"
import { TopupPayment } from "@src/pages/transactionsTopup/classes/TransactionsTopUpCollection"
import { catchErrors, convertsApi } from "@src/shared/api"
import {
  ConvertTokenResponse,
  Payment,
  PaymentExchange,
} from "@src/shared/api/generated"
import { loading } from "@src/shared/classes/utils/loading"

export type PaymentsEntityState = DepositPayment | Payment | TopupPayment

export class PaymentsEntity extends loading(["getConvertToken"]) {
  state = {} as PaymentsEntityState

  constructor(payment?: PaymentsEntityState) {
    super()

    if (payment) {
      this.state = { ...payment }
    }

    makeObservable(this, {
      getConvertToken: action.bound,
      hasExchange: computed,
      isRealExchanged: computed,
      state: observable.shallow,
    })
  }

  async getConvertToken(): Promise<ConvertTokenResponse | null> {
    const { exchange } = this.state

    if (!exchange) {
      return null
    }

    const { amount, network, symbol } = exchange

    try {
      const {
        data: { data },
      } = await convertsApi.getConvertToken(
        // @ts-ignore
        network,
        symbol,
        this.state.network,
        this.state.symbol,
        amount,
      )

      return data ?? null
    } catch (e: any) {
      catchErrors(e)
    }

    return null
  }

  get exchange(): Required<PaymentExchange> | null {
    return this.state.exchange
      ? (this.state.exchange as Required<PaymentExchange>)
      : null
  }

  get hasExchange(): boolean {
    return Boolean(this.exchange)
  }

  get isRealExchanged() {
    return this.hasExchange && (this.state.exchange as any).is_real_exchanged
  }
}
